import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackendApiService } from '../../../services/backend-api.service';
import { DialogService } from '../../../services/dialog.service';
import { Todo, TodoList } from '../todo';
import { MatIconButton } from '@angular/material/button';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'phito-todo-quick-entry-overlay',
    templateUrl: './todo-quick-entry-overlay.component.html',
    styleUrl: './todo-quick-entry-overlay.component.scss',
    imports: [
        MatIconButton,
        CdkOverlayOrigin,
        MatIcon,
        CdkConnectedOverlay,
        MatFormField,
        MatLabel,
        MatSelect,
        FormsModule,
        ReactiveFormsModule,
        MatOption,
        MatInput,
    ],
})
export class TodoQuickEntryOverlayComponent implements OnInit {
    private api = inject(BackendApiService);
    private dialogService = inject<DialogService<TodoList>>(DialogService);

    isToDoPanelOpen = false;
    todoCtrl = new FormControl();
    listSelectionCtrl = new FormControl();

    todoLists: TodoList[] = [];
    currentList: TodoList;

    public ngOnInit(): void {
        this.loadTodoLists();
        this.listSelectionCtrl.valueChanges.subscribe({
            next: (value) => {
                if (value) {
                    this.currentList = value;
                }
            },
        });
    }

    private loadTodoLists(): void {
        this.api.getAll('todolists').subscribe({
            next: (response) => {
                this.todoLists = <TodoList[]>response.data;
                if (this.currentList) {
                    this.currentList = this.todoLists.find((list) => list.id === this.currentList.id);
                    this.listSelectionCtrl.setValue(this.currentList, { emitEvent: false });
                } else if (!this.currentList && this.todoLists.length > 0) {
                    this.currentList = this.todoLists[0];
                    this.listSelectionCtrl.setValue(this.currentList, { emitEvent: false });
                } else {
                }
            },
            error: (err) => {
                console.error(err);
            },
        });
    }

    public addTodo(): void {
        if (this.todoCtrl.value === undefined || this.todoCtrl.value === '') {
            return;
        }
        const todo = new Todo();
        todo.title = this.todoCtrl.value;
        this.currentList?.todos?.unshift(todo);
        this.updateCurrentList();
    }

    private updateCurrentList(): void {
        this.api.update('todolists', this.currentList).subscribe({
            next: (response) => {
                this.currentList = response;
                this.loadTodoLists();
                this.todoCtrl.reset();
            },
            error: (err) => {
                console.error(err);
            },
        });
    }

    public createNewList(): void {
        this.dialogService.enterStringValue('Neue Liste anlegen', { buttonText: 'Anlegen' }).subscribe({
            next: (result) => {
                if (result?.isConfirmed()) {
                    const listName = result.getEntity().value;
                    const todoList = new TodoList();
                    todoList.listName = listName;
                    this.api.create('todolists', todoList).subscribe({
                        next: (response) => {
                            this.currentList = response;
                            this.loadTodoLists();
                        },
                        error: (err) => {
                            console.error(err);
                        },
                    });
                }
            },
        });
    }
}
